import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
}

export default function FiatWithdrawalIcon(props: SizeProps) {
  return (
    <svg
      width={props.height ? props.height : "40px"}
      height={props.width ? props.width : "40px"}
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Desktop---Transactions:-Trade-Detail---Note-added"
          transform="translate(-250.000000, -1127.000000)"
        >
          <g id="Group" transform="translate(220.000000, 354.000000)">
            <g id="Group" transform="translate(30.000000, 773.000000)">
              <circle id="Oval-Copy" fill="#F4E7E7" cx="20" cy="20" r="20"></circle>
              <g
                transform="translate(7.500000, 7.000000)"
                id="Icons-/-Line-/-Fiat-Withdrawal"
                stroke="#280101"
                strokeLinecap="round"
                strokeWidth="1.5"
              >
                <g>
                  <path
                    d="M15.277991,5.5 L23.1889653,5.5 C24.1959469,5.5071552 25.0066098,6.32901158 25,7.336 L25,20.164 C25.0066098,21.1709884 24.1959469,21.9928448 23.1889653,22 L1.81103474,22 C0.80405305,21.9928448 -0.00660983926,21.1709884 0,20.164 L0,7.336 C-0.00660983926,6.32901158 0.80405305,5.5071552 1.81103474,5.5 L9.72200903,5.5"
                    id="Path"
                  ></path>
                  <rect
                    id="Rectangle"
                    x="3.41802952"
                    y="13.698"
                    width="2.52099181"
                    height="2.521"
                    rx="0.092"
                  ></rect>
                  <line x1="3.41802952" y1="19.023" x2="5.93902132" y2="19.023" id="Path"></line>
                  <line x1="7.92301488" y1="19.023" x2="10.4440067" y2="19.023" id="Path"></line>
                  <line x1="12.4280002" y1="19.023" x2="14.948992" y2="19.023" id="Path"></line>
                  <line x1="16.9319856" y1="19.023" x2="19.4529774" y2="19.023" id="Path"></line>
                  <line
                    x1="12.5000002"
                    y1="14"
                    x2="12.5000002"
                    y2="0"
                    id="Path"
                    strokeLinejoin="round"
                  ></line>
                  <polyline
                    id="Path"
                    strokeLinejoin="round"
                    points="15.6999896 3 12.5 0 9.3000104 3"
                  ></polyline>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
